import { EditorSection } from '../EditorSection';
import { useCaps, usePlotEditorContext } from '../PlotEditorContext';
import { LegendControls } from '../legend-controls';

/**
 * Legend & Guides Tab
 * Primary: Legend basics, reference lines
 * Advanced: Legend styling, per-series legend visibility
 */
export function LegendGuidesTab() {
  const caps = useCaps();
  const { plotlyJson, onUpdate } = usePlotEditorContext();

  // Hide tab if legend is not supported
  if (!caps.supports.legend) {
    return (
      <div className="space-y-4">
        <div className="space-y-1">
          <h3 className="text-xs font-semibold text-foreground">Legend & Guides</h3>
          <p className="text-[11px] text-muted-foreground">
            Legend controls are not available for this chart type.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Section heading */}
      <div className="space-y-1">
        <h3 className="text-xs font-semibold text-foreground">Legend & Guides</h3>
        <p className="text-[11px] text-muted-foreground">
          Control legend visibility, position, and styling.
        </p>
      </div>

      {/* Legend */}
      <div className="space-y-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          Legend
        </p>
        <LegendControls plotlyJson={plotlyJson} onUpdate={onUpdate} />
      </div>

      {/* TODO: Add reference lines group */}
    </div>
  );
}

